import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["btn"]

  connect() {
    const saved = localStorage.getItem("czn-theme")
    if (saved === "light") {
      document.documentElement.classList.remove("theme-dark")
      document.documentElement.classList.add("theme-light")
      this.btnTarget.textContent = "☀"
    } else {
      document.documentElement.classList.remove("theme-light")
      document.documentElement.classList.add("theme-dark")
      this.btnTarget.textContent = "☾"
    }
  }

  toggle() {
    const isLight = document.documentElement.classList.toggle("theme-light")
    document.documentElement.classList.toggle("theme-dark", !isLight)
    localStorage.setItem("czn-theme", isLight ? "light" : "dark")
    this.btnTarget.textContent = isLight ? "☀" : "☾"
  }
}
